/*
  assets/pbg.js — PCs by Game

  Two jobs, both done over markup that is already on the page: filter the
  library as somebody types, and hide the overflow behind Show all games.

  WHY IT WORKS THIS WAY
  Every game link is rendered server side on every request. This file only
  ever adds and removes classes, so nothing is hidden from a crawler and
  nothing breaks without JavaScript — with the script blocked, the button
  never appears and the full library is simply open.

  NOTHING TO MAINTAIN
  There is no index, no fetch and no game list in here. Adding a game to
  snippets/pbg-data.liquid is the whole job. The shorthand map below is the
  one optional extra: it lets "cod" find Call of Duty. Leave it alone and
  everything still works on full titles.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-pbg-library]');
  if (!root) return;

  var input = root.querySelector('[data-pbg-search]');
  var clear = root.querySelector('[data-pbg-clear]');
  var grid = root.querySelector('[data-pbg-grid]');
  var popular = root.querySelector('[data-pbg-popular]');
  var count = root.querySelector('[data-pbg-count]');
  var empty = root.querySelector('[data-pbg-empty]');
  var more = root.querySelector('[data-pbg-more]');
  var toggle = root.querySelector('[data-pbg-toggle]');

  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-game]'));
  var total = cards.length;
  var initial = parseInt(root.getAttribute('data-initial'), 10) || 12;
  var expanded = false;

  /* Shorthand people actually type. Optional. */
  var SHORTHAND = {
    cod: 'call of duty',
    bo6: 'call of duty black ops',
    mw3: 'call of duty modern warfare',
    gta: 'grand theft auto',
    wow: 'world of warcraft',
    lol: 'league of legends',
    bg3: 'baldurs gate 3',
    cs: 'counter strike',
    cs2: 'counter strike 2',
    csgo: 'counter strike',
    ff14: 'final fantasy xiv',
    ffxiv: 'final fantasy xiv',
    fm: 'football manager',
    hd2: 'helldivers 2',
    ark: 'ark survival ascended',
    sims: 'the sims 4'
  };

  function normalise(value) {
    return (value || '')
      .toLowerCase()
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function setCollapsed(on) {
    grid.classList.toggle('is-collapsed', on);
  }

  function updateToggle() {
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var label = toggle.querySelector('[data-pbg-toggle-label]');
    if (label) {
      label.textContent = expanded
        ? toggle.getAttribute('data-less')
        : toggle.getAttribute('data-more');
    }
  }

  function report(visible, searching) {
    if (!count) return;
    if (!searching) {
      count.textContent = total + (total === 1 ? ' game' : ' games');
      return;
    }
    count.textContent = visible === 0
      ? 'No games found'
      : visible + ' of ' + total + (visible === 1 ? ' game' : ' games');
  }

  function filter() {
    var raw = normalise(input ? input.value : '');
    var query = SHORTHAND[raw] || raw;
    var searching = query.length > 0;
    var visible = 0;

    for (var i = 0; i < total; i++) {
      var card = cards[i];
      var hit = !searching || card.getAttribute('data-key').indexOf(query) !== -1;
      card.classList.toggle('is-out', !hit);
      if (hit) visible++;
    }

    /* Searching suspends both the promoted row and the collapse. */
    if (popular) popular.hidden = searching;
    setCollapsed(!searching && !expanded && total > initial);
    if (more) more.hidden = searching || total <= initial;
    if (empty) empty.hidden = !(searching && visible === 0);
    if (clear) clear.hidden = !searching;

    report(visible, searching);
  }

  if (total > initial) {
    setCollapsed(true);
    if (more) more.hidden = false;
    updateToggle();
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      expanded = !expanded;
      setCollapsed(!expanded);
      updateToggle();
      if (!expanded) {
        grid.scrollIntoView({ block: 'start', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    });
  }

  if (input) {
    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value !== '') {
        event.preventDefault();
        input.value = '';
        filter();
      }
    });
  }

  if (clear) {
    clear.addEventListener('click', function () {
      if (!input) return;
      input.value = '';
      filter();
      input.focus();
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  report(total, false);
})();
